import { navHistoryVar } from './cache'
import { graphql } from '@apollo/client/react/hoc'
import { createBrowserHistory } from 'history'

import getNavHistory from 'graphql/navigation/getNavHistory.gql'

export const history = createBrowserHistory()

export const sliceNavHistory = (sliceIndex) => {
    const { history: currentHistory } = navHistoryVar()

    navHistoryVar({
        historyIndex: 0,
        history: [
            ...currentHistory.slice(sliceIndex)
        ],
    })
}

const writeNavHistoryEntryObject = (location, match) => {
    const { pathname, hash, search, key } = location

    return {
        __typename: 'NavHistoryObject',
        pathname,
        hash,
        search,
        match: {
            __typename: 'LocationMatch',
            path: match.path,
        },
        key: key || null,
    }
}

export const writeNavHistoryEntry = (history, location, match) => {
    const { history: currentHistory, historyIndex: currentHistoryIndex } = navHistoryVar()

    const HISTORY_MAX_LEN = 50

    let newHistory = currentHistory
    let newHistoryIndex = currentHistoryIndex

    switch (history.action) {
    case 'REPLACE':
        newHistoryIndex = 0
        newHistory = [
            writeNavHistoryEntryObject(location, match),
            ...currentHistory.slice(1 + currentHistoryIndex)
        ]
        break
    case 'POP':
            // check if browser back button POP by comparing keys in history
        if (currentHistory.length >= currentHistoryIndex + 2 && currentHistory[currentHistoryIndex + 1].key === location.key) {
            newHistoryIndex++
        } else if (currentHistoryIndex > 0 && currentHistory.length >= currentHistoryIndex && currentHistory[currentHistoryIndex - 1].key === location.key) {
            newHistoryIndex--
        } else {
            newHistoryIndex = 0
            newHistory = [
                writeNavHistoryEntryObject(location, match)
            ]
        }
        break
    default:
        newHistoryIndex = 0
        newHistory = [
            writeNavHistoryEntryObject(location, match),
            ...currentHistory.slice(currentHistoryIndex)
        ]
    }

    navHistoryVar({
        historyIndex: newHistoryIndex,
        history: newHistory.slice(0, HISTORY_MAX_LEN),
    })
}

export const getPrevLocation = () => {
    const { historyIndex, history } = navHistoryVar()
    return {
        prevLocation: history && history.length > 1 + historyIndex
            ? history[1 + historyIndex]
            : null,
    }
}

export const getPrevLocationFullPath = (prevLocation, defaultValue = false) => {
    return prevLocation.pathname ? prevLocation.pathname + prevLocation.search : defaultValue
}

export const graphqlPrevLocationCached = graphql(getNavHistory, {
    name: 'navHistory',
    props: (data) => {
        const { historyIndex, history } = data.navHistory.navHistory
        return {
            prevLocation: history && history.length > 1 + historyIndex ? history[1 + historyIndex] : null,
        }
    },
    options: {
        fetchPolicy: 'cache-only',
    },
})

export const graphqlNavHistoryCached = graphql(getNavHistory, {
    name: 'navHistory',
    props: (data) => {
        return {
            navHistoryIndex: data.navHistory.navHistory.historyIndex,
            navHistory: data.navHistory.navHistory.history,
        }
    },
    options: {
        fetchPolicy: 'cache-only',
    },
})
